import { useState } from 'react';

/**
 * Estado de recolhimento da barra lateral.
 *
 * Recolher é preferência de quem trabalha na tela o dia todo, então atravessa
 * recarregamentos. Vive aqui, e não em cada app, porque admin e app do aluno
 * têm a mesma barra e o mesmo comportamento - inclusive a sutileza do
 * recolhimento por largura de tela.
 */
export function useBarraRecolhida(chave: string) {
  const [recolhida, setRecolhida] = useState(() => globalThis.localStorage?.getItem(chave) === '1');

  /** Escolha de quem usa: fica guardada. */
  const escolher = (valor: boolean) => {
    setRecolhida(valor);
    globalThis.localStorage?.setItem(chave, valor ? '1' : '0');
  };

  /**
   * Recolhimento imposto pela largura da tela. Não é guardado: o Sider dispara
   * o evento também na montagem, e em tela larga ele expandia a barra por conta
   * própria, apagando a preferência de quem tinha recolhido.
   */
  const recolherPorTela = (valor: boolean) => {
    if (valor) setRecolhida(true);
  };

  return { recolhida, escolher, recolherPorTela };
}
